export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx60_sell.5ba96b0d.mp3";